import { render, staticRenderFns } from "./addSubarea.vue?vue&type=template&id=5fe5efce&scoped=true&"
import script from "./addSubarea.vue?vue&type=script&lang=js&"
export * from "./addSubarea.vue?vue&type=script&lang=js&"
import style0 from "./addSubarea.vue?vue&type=style&index=0&id=5fe5efce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5efce",
  null
  
)

export default component.exports